import React from 'react';
import moment from 'moment';

import { DEFAULT_TIME_FORMAT } from '../constants/TimeCalculation.constants';

export const Time = ({ value }) => {
  if (!value) {
    return '';
  }

  return <span>{moment.utc(value).format(DEFAULT_TIME_FORMAT)}</span>;
};

export const FormatLastPADate = (props) => {
  if (!props.value) {
    return null;
  }

  return <Time value={props.value} />;
};
